// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b7-4";
export var collapsed = "_b7-1";
export var headerBar = "_b7-0";
export var leftHeaderContent = "_b7-3";
export var subjectContainer = "_b7-2";